const NextIcon = () => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5.1748 1.6751C5.3248 1.6751 5.4748 1.7251 5.5748 1.8501L11.2248 7.6001C11.4498 7.8251 11.4498 8.1751 11.2248 8.4001L5.5748 14.1501C5.3498 14.3751 4.9998 14.3751 4.7748 14.1501C4.5498 13.9251 4.5498 13.5751 4.7748 13.3501L10.0248 8.0001L4.7498 2.6501C4.5248 2.4251 4.5248 2.0751 4.7498 1.8501C4.8998 1.7501 5.0248 1.6751 5.1748 1.6751Z'
        fill='#9CA3AF'
      />
    </svg>
  );
};

export default NextIcon;
